import {
  Alert,
  Button,
  Divider,
  Form,
  Modal,
  Select,
  Typography,
  message,
} from "antd";
import MainCreateOrderPayment from "../../CreateOrders/PaymentSection/MainCreateOrderPayment";
import MainOrderDatasource from "../../CreateOrders/DatasourceSection/MainOrderDatasource";
import MainCreateOrderProduct from "../../CreateOrders/ProductSection/MainCreateOrderProduct";
import {
  useGetBankActiveList,
  useGetBankAllList,
  useGetRetailDataById,
  useGetTransportationTypeByFactory,
} from "hooks/useFactory";
import { useAppSelector } from "store";
import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import {
  AddAddressDataInput,
  AgentByIdResponse,
  FactoryUpdateOrderInput,
  GetOrderDetailData,
  MasterDistrictData,
  MasterLocationTypeData,
  MasterProvinceData,
  MasterSubDistrictData,
  MasterTransportData,
  OrderProductsTemporaryItem,
  PaymentUpdateOrderItems,
  PriceTransportationInput,
  RemoveAddressDataInput,
  TaxAddressData,
  TaxInvoiceOrderItems,
  UpdateAddressDataInput,
  UpdateOrderList,
  UpdateOrderShipAddress,
} from "services/interface";
import styled from "@emotion/styled";
import AgentAddressForm from "./AgentAddressForm";
import {
  useGetLocationType,
  useGetMasterDistrict,
  useGetMasterProvince,
  useGetMasterSubDistrict,
  useGetTransportType,
} from "hooks/useMasterData";
import {
  useLoadTaxInvoiceList,
  useLoadTaxInvoiceListMutation,
  useMutatePriceTransportation,
  useUpdateOrderAdmin,
} from "hooks/useOrders";
import { backendUrl } from "config";
import MainCreatePriceTransportation from "../../CreateOrders/PriceTransportationSection/MainCreatePriceTransportation";
import MainCreateTotalPricePayment from "../../CreateOrders/TotalPricePaymentSection/MainCreateTotalPricePayment";
import AgentAddressCardList from "components/ManageAgent/CreateAgent/AddressComponents/AgentAddressCardList";
import { AddressData } from "components/ManageAgent/CreateAgent/AddressComponents/interface/address.interface";
import {
  useAddAddressData,
  useGetAgentDataById,
  useRemoveAddressData,
  useUpdateAddressData,
} from "hooks/useAgents";
import MainCreateOrderAddress from "../../CreateOrders/AddressSection/MainCreateOrderAddress";
import MainCreateAgentAddress from "../../CreateOrders/AddressSection/MainCreateAgentAddress";
import AddressCardList from "../../CreateOrders/AddressSection/AddressCardList";
import UpdateAgentAddressForm from "components/ManageAgent/CreateAgent/AddressComponents/UpdateAgentAddressForm";
import CreateAgentAddressForm from "components/ManageAgent/CreateAgent/AddressComponents/CreateAgentAddressForm";
import { PlusOutlined } from "@ant-design/icons";
import MainCreateOrderTax from "../../CreateOrders/TaxSection/MainCreateOrderTax";
import { useGetParkingTransportAreaTypeMutation } from "hooks/useShipping";

const { Option } = Select;
interface ModalUpdateOrderProps {
  refId?: string;
  refType?: string;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  refetchData: any; //() => void;
  item: GetOrderDetailData;
  isProductProblem: boolean;
  forceOpen: (
    order_id: string,
    is_problem: boolean,
    payment_status: string,
    payment_amount: number,
    final_price: number
  ) => void;
}

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const ModalUpdateOrder: FC<ModalUpdateOrderProps> = ({
  open,
  setOpen,
  refetchData,
  item,
  isProductProblem,
  forceOpen,
  refId,
  refType,
}) => {
  const [formAdd] = Form.useForm();
  const [formEdit] = Form.useForm();
  const [formAddress] = Form.useForm();

  const [dataAddress, setDataAddress] = useState<AddressData[]>([]);
  const [dataAddressTax, setDataAddressTax] = useState<TaxAddressData[]>([]);
  const [requestTax, setRequestTax] = useState<boolean>(false);

  const [userData, setUserData] = useState<AgentByIdResponse>();
  const [radioSelect, setRadioSelect] = useState<string>("");
  const [provinceId, setProvinceId] = useState<number>(0);
  const [districtId, setDistrictId] = useState<number>(0);

  const { mutate: AgentDataById } = useGetAgentDataById();
  const { mutate: RetailDataById } = useGetRetailDataById();

  const factoryId = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );

  const { data: masterProviceData, isPending: proviceLoading } =
    useGetMasterProvince();
  const { mutate: AddAddress, isPending: AddAddressIsLoading } =
    useAddAddressData();
  const { mutate: UpdateAddress, isPending: UpdateAddressIsLoading } =
    useUpdateAddressData();
  const { mutate: calServicePrice } = useMutatePriceTransportation();

  const [editingKey, setEditingKey] = useState("");
  const [currentSelected, setCurrentSelected] = useState<string>("");
  const [selectedLocationEdit, setSelectedLocationEdit] = useState<string>("");
  const [addressIdSelected, setAddressIdSelected] = useState<string>("");
  const [selectedLocation, setSelectedLocation] = useState<string>("");

  const [transport, setTransport] = useState<string>("");
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [servicePrice, setServicePrice] = useState<number>(0);
  const [disCount, setDisCount] = useState<number>(0);

  const [add, setAdd] = useState(false);
  const [edit, setEdit] = useState(false);

  const [messageError, setMessageError] = useState<string>("");

  const { mutate: mutateParkingTransportAreaType } =
    useGetParkingTransportAreaTypeMutation();

  // const {
  //   data: dataTax,
  //   isPending: taxPending,
  //   refetch: refetchTax,
  // } = useLoadTaxInvoiceList({
  //   factory_id: factoryId ?? '',
  //   customer_id: refId ?? '',
  // });

  const { data: dataTax, mutate } = useLoadTaxInvoiceListMutation();

  useEffect(() => {
    if (refId && refType) {
      mutate({
        factory_id: factoryId ?? "",
        customer_id: refId,
      });
    }
  }, [refId, refType]);

  const refetchTax = () => {
    if (refId && refType) {
      mutate({
        factory_id: factoryId ?? "",
        customer_id: refId,
      });
    }
  };

  useEffect(() => {
    if (refId && dataTax?.data) {
      const newTaxAddresses: TaxAddressData[] = dataTax.data.map(
        (tax: TaxAddressData) => {
          return {
            id: tax.id,
            name: tax.name,
            address_text: tax.address_text,
            telephone: tax.telephone,
            fax: tax.fax,
            email: tax.email,
            tax_no: tax.tax_no,
            factory_id: factoryId ?? "",
            ref_id: refId,
            ref_type: refType ?? "",
            is_active: tax.is_active,
          };
        }
      );

      setDataAddressTax(newTaxAddresses);

      const activeAddress = newTaxAddresses.find((tax) => tax.is_active);
      if (activeAddress) {
        setAddressIdSelected(activeAddress.id);
      } else {
        setAddressIdSelected("");
      }
    }
  }, [refType, dataTax]);

  const { mutate: updateOrder } = useUpdateOrderAdmin();
  const { mutate: RemoveAddress, isPending: RemoveAddressIsLoading } =
    useRemoveAddressData();

  const [dataTemporary, setDataTemporary] = useState<
    OrderProductsTemporaryItem[]
  >([]);
  const [formSubmit] = Form.useForm();

  //console.log("dataTemporary--->", dataTemporary);

  const [haveAgentCode, setHaveAgentCode] = useState<boolean>(false);
  const [province, setProvince] = useState<MasterProvinceData[]>([]);
  const [district, setDistrict] = useState<MasterDistrictData[]>([]);
  const [subDistrict, setSubDistrict] = useState<MasterSubDistrictData[]>([]);
  const [location, setLocation] = useState<MasterLocationTypeData[]>([]);
  const [transportList, setTransportList] = useState<MasterTransportData[]>([]);

  const { data: masterTransportData, isPending: transportLoading } =
    useGetTransportType();
  const { data: masterLocationData, isPending: locationLoading } =
    useGetLocationType();
  const { data: masterDistrictData, isPending: districtLoading } =
    useGetMasterDistrict(provinceId);
  const { data: masterSubDistrictData, isPending: subDistrictLoading } =
    useGetMasterSubDistrict(districtId);

  const showDrawer = () => {
    setAdd(true);
  };

  // const factoryId = useAppSelector((state) => state.auth.profile?.user?.role?.ref_id);
  const { data: TransportationTypeData } = useGetTransportationTypeByFactory(
    factoryId ?? ""
  );

  const refetchUserData = () => {
    if (refType === "agent") {
      AgentDataById(refId || "", {
        onSuccess: async (data) => {
          setUserData(data.data);
          // setModalData(data);
          // setMasterTransportId(id)
        },
        onError: (error) => {
          console.log(error);
          // dispatch(setLoading(false));
        },
      });
    } else if (refType === "retail") {
      RetailDataById(refId || "", {
        onSuccess: async (data) => {
          setUserData(data.data);
          // setModalData(data);
          // setMasterTransportId(id)
        },
        onError: (error) => {
          console.log(error);
          // dispatch(setLoading(false));
        },
      });
    }
  };
  useEffect(() => {
    refetchUserData();
  }, [refId, refType]);

  useEffect(() => {
    const addressShip = dataAddress.find(
      (address) => address.address_id === radioSelect
    );

    if (!addressShip?.province_id) {
      return;
    }

    mutateParkingTransportAreaType(
      {
        factory_id: factoryId || "",
        province_id: addressShip?.province_id ?? 0,
        district_id: addressShip?.district_id ?? 0,
      },
      {
        onSuccess: (data) => {
          // ตรวจสอบว่า data มีค่าไหม
          if (data.data.length > 0) {
            // fitter ข้อมูลใน data.data ที่ config_list ไม่เป็นค่าว่าง ออก
            const newData = data.data.filter(
              (item) => item.config_list.length > 0
            );
            // ตรวจสอบว่า newData มีค่าไหม
            if (newData.length > 0) {
              // ตรวจสอบว่า newData[0].transport_type ตรงกับ shipAddress.transport_type หรือไม่
              const isMatch = newData.some(
                (item) => item.transport_type === addressShip?.transport_type
              );
              if (isMatch) {
                console.log("ตรงกัน");
                // onFinishAfterCheck(values);
                setMessageError("");
              } else {
                setMessageError(
                  "ที่อยู่ที่คุณเลือกไม่รองรับการจัดส่งของโรงงาน กรุณาเลือกที่อยู่ใหม่"
                );
                message.error(
                  "ที่อยู่ที่คุณเลือกไม่รองรับการจัดส่งของโรงงาน กรุณาเลือกที่อยู่ใหม่"
                );
              }
            } else {
              setMessageError(
                "ที่อยู่ที่คุณเลือกไม่รองรับการจัดส่งของโรงงาน กรุณาเลือกที่อยู่ใหม่"
              );
              message.error(
                "ที่อยู่ที่คุณเลือกไม่รองรับการจัดส่งของโรงงาน กรุณาเลือกที่อยู่ใหม่"
              );
            }
          }
        },
      }
    );
    if (addressShip) {
      setTransport(addressShip?.transport_type ?? "");
    }
  }, [dataAddress, radioSelect, factoryId]);

  useEffect(() => {
    if (userData) {
      // dataAddress
      const newAddresses: AddressData[] = userData?.address_ship?.map(
        (address) => {
          return {
            address_id: address.address_id,
            transport_type: address.transport_type,
            line_1: address.address_line_1,
            line_2: address.address_line_2,
            location_type: address.location_type,
            address_text: address.address_text,
            province_id: address.province_id,
            province_name: address.province_name,
            district_id: address.district_id,
            district_name: address.district_name,
            sub_district_id: address.sub_district_id,
            sub_district_name: address.sub_district_name,
            post_code: address.zip_code,
            address_type: address.address_type,
            address_name: address.address_name,
            address_telephone: address.address_telephone,
            address_remark: address.address_remark,
            is_default: address?.is_default,
          };
        }
      );

      setDataAddress(newAddresses);
    }
  }, [userData]);

  useEffect(() => {
    if (open) {
      formSubmit.resetFields();
      setDataTemporary([]);

      if (item) {
        formSubmit.setFieldsValue({ datasource: item.datasource });
        const tempData: OrderProductsTemporaryItem[] = item.items.map((w) => ({
          order_item_id: w.order_item_id,
          factory_id: "",
          product_id: w.product_id,
          product_name: w.product_name,
          sku_id: w.sku_id,
          sku_name: w.sku_description,
          sku_image: w.image_url,
          price_id: w.price_id,
          factory_price: w.factory_price,
          wholesale_price: w.wholesale_price,
          retail_price: w.retail_price,
          vip_price: w.vip_price,
          qty: w.sku_cnt,
          product_quantity: 0,
          item_status_process: w.item_status_process,
          comment_text: w.contact_comment_item,
        }));

        setTransport(item.transport_type);
        setDataTemporary(tempData);
        setDisCount(item?.discount_amount || 0);
        setRadioSelect(item.address_id);
        setHaveAgentCode(false);
        setRequestTax(item.tax_invoice?.taxinvoice_id ? true : false);
      }
    }
  }, [item, open]);

  useEffect(() => {
    if (item) {
      const refIdKey = refType === "agent" ? "agent_id" : "retail_id";
      const addressShip = dataAddress.find(
        (address) => address.address_id === radioSelect
      );

      let calInput: PriceTransportationInput;
      if ((addressShip?.province_id ?? 0) > 0) {
        calInput = {
          transport_type: transport,
          total_price: totalPrice,
          province_id: addressShip?.province_id ?? 0,
          district_id: addressShip?.district_id ?? 0,
          factory_id: factoryId || "",
          // [refIdKey]: item.ref_id || '',
        };
      } else {
        calInput = {
          transport_type: item.transport_type,
          total_price: totalPrice,
          province_id: item.province_id,
          district_id: item.district_id,
          factory_id: factoryId || "",
          // [refIdKey]: item.ref_id || '',
        };
      }

      calServicePrice(calInput, {
        onSuccess: async (data) => {
          console.log(data.data);
          setServicePrice(data.data.service_price);
        },
        onError: (error) => {
          console.log(error);
        },
      });
    }
  }, [transport, totalPrice, factoryId]);

  const { data: dataBank } = useGetBankActiveList(factoryId || "");
  const childrenBank: React.ReactNode[] = [];
  dataBank?.data?.map((item) => {
    return childrenBank.push(
      <Option key={item.id} value={item.id}>
        {item.bank_name} {item.account_no} {item.account_name}
      </Option>
    );
  });
  const onCloseEdit = () => {
    setEdit(false);
    formEdit.resetFields();
    setSelectedLocationEdit("");
  };
  const handleRemoveItem = (target: string) => {
    const selectedDataAddress = dataAddress.find(
      (item) => item.address_id === target
    );
    const dataInput: RemoveAddressDataInput = {
      ref_id: userData?.id || "",
      ref_type: userData?.contact_type || "",
      id: selectedDataAddress?.address_id || "",
    };
    RemoveAddress(dataInput, {
      onSuccess: (res) => {
        if (res.status === "success") {
          message.success("ลบที่อยู่ลูกค้าสำเร็จ");
          refetchUserData();
        } else {
          message.error(`ลบที่อยู่ลูกค้าไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        message.error(`ลบที่อยู่ลูกค้าไม่สำเร็จ: ${error.message}`);
      },
    });

    // const updatedDataAddress = dataAddress.filter((item, index) => index !== target);
    // setDataAddress(updatedDataAddress);
  };

  const onCloseAdd = () => {
    setAdd(false);
  };

  const onClose = () => {
    setOpen(false);

    resetForm();
    forceOpen(
      item.order_id,
      isProductProblem,
      item.payment_status,
      Number(item.payment_amount),
      Number(item.final_price)
    );
  };

  const resetForm = () => {
    setEditingKey("");
    setCurrentSelected("");
    formSubmit.resetFields();
    setDataTemporary([]);
  };

  const onFinishUpdate = (values: any) => {
    if (!values.datasource) {
      message.error("กรุณาเลือกช่องทางการสั่งซื้อ");
      return;
    }

    if (radioSelect === null || radioSelect === "") {
      message.error("กรุณาเลือกที่อยู่จัดส่ง");
      return;
    }
    let shipAddressData: UpdateOrderShipAddress | undefined;

    const addressShip = dataAddress.find(
      (address) => address.address_id === radioSelect
    );
    // console.log(addressShip);
    if (addressShip) {
      shipAddressData = {
        id: item?.order_address_id || "",
        address_id: addressShip.address_id || "",
        address_line_1: addressShip.line_1 || "",
        address_line_2: addressShip.line_2 || "",
        ref_id: item?.order_id || "",
        address_name: addressShip.address_name || "",
        address_telephone: addressShip.address_telephone || "",
        transport_type: addressShip.transport_type || "",
        location_type: addressShip.location_type || "",
        province_id: addressShip.province_id || 0,
        province_name: addressShip.province_name || "",
        district_id: addressShip.district_id || 0,
        district_name: addressShip.district_name || "",
        sub_district_id: addressShip.sub_district_id || 0,
        sub_district_name: addressShip.sub_district_name || "",
        zip_code: Number(addressShip.post_code) || 0,
        remark: addressShip.address_remark,
        // geolocation_th: "",
        // geolocation_en: "",
        // country_th: "",
        // country_en: "",
        // geolocation: "",
        // location_text: "",
        address_text: addressShip.address_text || "",
      };
    } else if (item.discount_code) {
      shipAddressData = {
        id: item.order_address_id || "",
        address_id: item.address_id || "",
        address_line_1: item.address_line_1 || "",
        address_line_2: item.address_line_2 || "",
        ref_id: item.order_id || "",
        address_name: item.address_name || "",
        address_telephone: item.address_telephone || "",
        transport_type: item.transport_type || "",
        // location_type: item.location_text || "",
        province_id: item.province_id || 0,
        province_name: item.province_name || "",
        district_id: item.district_id || 0,
        district_name: item.district_name || "",
        sub_district_id: item.sub_district_id || 0,
        sub_district_name: item.sub_district_name || "",
        zip_code: Number(item.zipcode) || 0,
        remark: item.address_remark,
        // geolocation_th: "",
        // geolocation_en: "",
        // country_th: "",
        // country_en: "",
        // geolocation: "",
        // location_text: "",
        address_text: item.address_text || "",
      };
    }

    // } else {
    //   const selectedDistrict = masterDistrictData?.find((item: MasterDistrictData) => item.id === values.district_id_ship);
    //   const selectedSubDistrict = masterSubDistrictData?.find((item: MasterSubDistrictData) => item.id === values.sub_district_id_ship);
    //   const selectedProvince = masterProviceData?.find((item: MasterProvinceData) => item.id === values.province_id_ship);

    //   shipAddressData = {
    //     id:                item?.order_address_id ?? '',
    //     address_id:        item?.address_id ?? '',
    //     ref_id:            item?.order_id ?? '',
    //     address_line_1:    values.line_1,
    //     address_line_2:    values.line_2,
    //     province_id:      values.province_id_ship,
    //     province_name:    selectedProvince?.name_th || '',
    //     district_id:       values.district_id_ship,
    //     district_name:    selectedDistrict?.name_th || '',
    //     sub_district_id:   values.sub_district_id_ship,
    //     sub_district_name: selectedSubDistrict?.name_th || '',
    //     zip_code:          values.zip_code_ship,
    //     // latitude:         '',
    //     // longitude:        '',
    //     // location_text:    '',
    //     // address_text:      '',
    //     address_name:      values.address_name,
    //     address_telephone: values.address_telephone,
    //     // address_detail:    '',
    //     transport_type:   values.transport,
    //     location_type:     values.location_type,
    //     remark: values.remark,
    //   }
    // }

    const updateOrderList: UpdateOrderList[] = [];

    console.log("dataTemporary--update->", dataTemporary);

    dataTemporary.map((w) => {
      const newData: UpdateOrderList = {
        order_item_id: w.order_item_id || "",
        product_id: w.product_id,
        price_id: w.price_id || "",
        qty: w.qty,
        comment_text: w.comment_text || "",
      };
      updateOrderList.push(newData);
    });

    const addressTax = dataAddressTax.find(
      (address) => address.id === addressIdSelected
    );
    let taxInvoiceItems: TaxInvoiceOrderItems | null = null;
    if (addressTax) {
      taxInvoiceItems = {
        tax_invoice_id: addressTax?.id,
        factory_id: factoryId || "",
        ref_id: refId || "",
        ref_type: refType || "",
        tax_no: addressTax?.tax_no || "",
        name: addressTax?.name || "",
        address: addressTax?.address_text || "",
        telephone: addressTax?.telephone || "",
        // fax: addressTax?.fax || null,
        // email: addressTax?.email || null,
      };
    }

    console.log("updateOrderList---->", updateOrderList);

    let updateOrderInput: FactoryUpdateOrderInput = {
      order_id: item?.order_id ?? "",
      datasource: values.datasource,
      order_list: updateOrderList,
      ship_address: shipAddressData,
      discount_amount: disCount,
      transport_price: servicePrice,
      req_tax: requestTax,
      ...(taxInvoiceItems && requestTax
        ? { tax_invoice: taxInvoiceItems }
        : {}),
    };

    // const updatePaymentOrder:PaymentUpdateOrderItems = {
    //   bank_id:      values.bank_id,
    //   image_slip:   values.payment_images,
    //   payment_date: values.payment_date,
    // }

    if (values.bank_id || values.payment_images || values.payment_date) {
      let imageSlipData = "";
      if (values.payment_images) {
        if (values.payment_images[0].id) {
          imageSlipData = `${backendUrl}images/${values.payment_images[0].id}`;
        } else {
          imageSlipData = values.payment_images[0].url;
        }
      }
      const updatePaymentOrder: PaymentUpdateOrderItems = {
        bank_id: values.bank_id,
        image_slip: imageSlipData,
        payment_date: values.payment_date,
      };
      updateOrderInput = {
        ...updateOrderInput,
        payment: updatePaymentOrder,
      };
    }

    updateOrder(updateOrderInput, {
      onSuccess: (res) => {
        if (res.status === "success") {
          message.success("แก้ไขคำสั่งซื้อสำเร็จ");
          refetchData();
          onClose();
          forceOpen(
            item.order_id,
            isProductProblem,
            item.payment_status,
            Number(item.payment_amount),
            Number(item.final_price)
          );
        } else {
          message.error(`แก้ไขคำสั่งซื้อไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        message.error(`แก้ไขคำสั่งซื้อไม่สำเร็จ: ${error.message}`);
      },
    });
  };

  const changeDefault = (id: string) => {
    console.log(id);
    setRadioSelect(id);
    // const targetAddress = dataAddress.find((address) => address.address_id === id || address.temp_id === id);

    // if (targetAddress) {
    //   const updatedData = dataAddress.map((address) => ({
    //     ...address,
    //     is_default: address.address_id === id || address.temp_id === id,
    //   }));

    //   setDataAddress(updatedData);
    // }
  };

  const showEdit = (id: string) => {
    setEdit(true);
    const dataEdit = dataAddress.find(
      (item: AddressData) => item.address_id === id || item.temp_id === id
    );
    setAddressIdSelected(dataEdit?.address_id ?? dataEdit?.temp_id ?? "");
    const selectedTransport = TransportationTypeData?.data?.find(
      (item) => item.key === dataEdit?.transport_type
    );
    setSelectedLocationEdit(selectedTransport?.location ?? "");
    setProvinceId(dataEdit?.province_id ?? 0);
    setDistrictId(dataEdit?.district_id ?? 0);
    formEdit.setFieldsValue({
      transport: dataEdit?.transport_type,
      province_id_ship: dataEdit?.province_id,
      address_name: dataEdit?.address_name,
      address_telephone: dataEdit?.address_telephone,
      line_1: dataEdit?.line_1,
      line_2: dataEdit?.line_2,
      location_type: dataEdit?.location_type,
      district_id_ship: dataEdit?.district_id,
      sub_district_id_ship: dataEdit?.sub_district_id,
      zip_code_ship: dataEdit?.post_code,
      address_detail: dataEdit?.address_remark,
      remark: dataEdit?.remark,
    });
  };

  const onFinish = (values: any) => {
    const dataInput: AddAddressDataInput = {
      ref_id: userData?.id || "",
      ref_type: userData?.contact_type || "",
      transport_type: values?.transport,
      address_type: "ship",
      address_name: values?.address_name,
      address_telephone: values?.address_telephone,
      address_detail: values?.address_detail,

      line_1: values?.line_1,
      line_2: values?.line_2,
      district_id: values?.district_id_ship,
      province_id: values?.province_id_ship,
      sub_district_id: values?.sub_district_id_ship,
      post_code: values?.zip_code_ship,
      parking_id: values?.parking_id,
      location_type: values?.location_type,
      remark: values?.remark,
    };
    AddAddress(dataInput, {
      onSuccess: (res) => {
        if (res.status === "success") {
          message.success("สร้างที่อยู่ลูกค้าสำเร็จ");
          refetchUserData();
        } else {
          message.error(`สร้างที่อยู่ลูกค้าไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        message.error(`สร้างที่อยู่ลูกค้าไม่สำเร็จ: ${error.message}`);
      },
    });

    // setDataAddress([...dataAddress, data]);
    onCloseAdd();
  };

  const onEdit = (values: any) => {
    const dataInput: UpdateAddressDataInput = {
      id: addressIdSelected,
      ref_id: userData?.id || "",
      ref_type: userData?.contact_type || "",
      transport_type: values?.transport,
      address_type: "ship",
      address_name: values?.address_name,
      address_telephone: values?.address_telephone,
      address_detail: values?.address_detail,

      line_1: values?.line_1,
      line_2: values?.line_2,
      district_id: values?.district_id_ship,
      province_id: values?.province_id_ship,
      sub_district_id: values?.sub_district_id_ship,
      post_code: values?.zip_code_ship,
      // address_taxno: values?.address_taxno,
      parking_id: values?.parking_id,
      location_type: values?.location_type,
      remark: values?.remark,
    };
    UpdateAddress(dataInput, {
      onSuccess: (res) => {
        if (res.status === "success") {
          message.success("แก้ไขที่อยู่ลูกค้าสำเร็จ");
          refetchUserData();
        } else {
          message.error(`แก้ไขที่อยู่ลูกค้าไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        message.error(`แก้ไขที่อยู่ลูกค้าไม่สำเร็จ: ${error.message}`);
      },
    });
    setEdit(false);
  };

  return (
    <>
      <Modal
        title={`แก้ไขคำสั่งซื้อ ${item?.order_code}`}
        open={open}
        width={1200}
        maskClosable={false}
        onCancel={onClose}
        style={{ top: 20 }}
        // onOk={() => {
        //   // onFinishAdd();
        //   if(messageError){
        //     message.error(messageError);
        //     return;
        //   }
        //   formSubmit.submit();
        // }}
        // cancelText="ยกเลิก"
        // okText="บันทึกคำสั่งซื้อ"
        footer={[
          <Button key="back" onClick={onClose}>
            ยกเลิก
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={dataTemporary.length === 0}
            onClick={() => {
              // onFinishAdd();
              if (messageError) {
                message.error(messageError);
                return;
              }
              formSubmit.submit();
            }}>
            บันทึกคำสั่งซื้อ
          </Button>,
        ]}>
        <WrapperAll>
          <Form form={formSubmit} onFinish={onFinishUpdate}>
            {item && (
              <>
                <HeadWrapper>
                  <Typography.Text
                    style={{
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                    underline>
                    ที่อยู่ในการจัดส่ง
                  </Typography.Text>
                  <ButtonWrapper>
                    {!item.discount_code && (
                      <StyledButton type="primary" onClick={showDrawer}>
                        <PlusOutlined /> สร้างที่อยู่จัดส่ง
                      </StyledButton>
                    )}
                  </ButtonWrapper>
                </HeadWrapper>
                {item.discount_code ? (
                  <>
                    <Alert
                      message="แจ้งเตือน"
                      description="ไม่สามารถแก้ไขที่อยู่ได้ เนื่องจากเป็นคำสั่งซื้อที่ใช้รหัสส่วนลด"
                      type="warning"
                      showIcon
                    />
                  </>
                ) : (
                  <>
                    <AddressCardList
                      dataAddress={dataAddress}
                      form={formAdd}
                      setDataAddress={setDataAddress}
                      handleRemoveItem={handleRemoveItem}
                      showEdit={showEdit}
                      changeDefault={changeDefault}
                      setRadio={setRadioSelect}
                      radio={item.address_id}
                    />
                  </>
                )}
              </>
            )}
            {messageError && (
              <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                <Alert message={messageError} type="error" />
              </div>
            )}
            <Divider />
            <MainCreateOrderTax
              refetchData={refetchTax}
              dataAddressTax={dataAddressTax}
              setDataAddressTax={setDataAddressTax}
              refId={refId ?? ""}
              refType={refType ?? ""}
              requestTax={requestTax}
              setRequestTax={setRequestTax}
              addressIdSelected={addressIdSelected}
              setAddressIdSelected={setAddressIdSelected}
            />
            <Divider />
            <MainOrderDatasource form={formSubmit} />
            <Divider />
            <MainCreateOrderProduct
              refId={refId || ""}
              refType={refType || ""}
              dataTemporary={dataTemporary}
              setDataTemporary={setDataTemporary}
              canDelete={true}
              canCreate={true}
              showStatusColumn={true}
              setTotalPrice={setTotalPrice}
              editingKey={editingKey}
              setEditingKey={setEditingKey}
              currentSelected={currentSelected}
              setCurrentSelected={setCurrentSelected}
              userData={userData}
              order_payment_type={item?.order_payment_type}
              item={item}
            />
            <MainCreatePriceTransportation servicePrice={servicePrice} />
            <MainCreateTotalPricePayment
              servicePrice={servicePrice}
              totalPrice={totalPrice}
              disCount={disCount}
              setDisCount={setDisCount}
              order_payment_type={item?.order_payment_type}
            />
          </Form>
        </WrapperAll>
      </Modal>
      <Modal
        title="สร้างที่อยู่จัดส่ง"
        open={add}
        maskClosable={false}
        onCancel={onCloseAdd}
        // width={1000}
        // footer={null}
        style={{ top: 20 }}
        onOk={() => {
          //onClose(); // ปิด Modal
          // เรียกใช้ callback function ที่ส่งเข้ามา
          formAddress.submit(); // ตัวอย่างการ submit form
        }}
        cancelText="ยกเลิก"
        okText="ตกลง">
        <Form form={formAddress} {...formItemLayout} onFinish={onFinish}>
          <CreateAgentAddressForm
            form={formAddress}
            masterLocationData={masterLocationData}
            masterTransportData={TransportationTypeData?.data}
            masterProviceData={masterProviceData}
            masterDistrictData={masterDistrictData}
            masterSubDistrictData={masterSubDistrictData}
            selectedLocation={selectedLocation}
            setSelectedLocation={setSelectedLocation}
            setProvinceId={setProvinceId}
            setDistrictId={setDistrictId}
          />
        </Form>
      </Modal>

      <Modal
        title="แก้ไขที่อยู่จัดส่ง"
        open={edit}
        maskClosable={false}
        onCancel={onCloseEdit}
        style={{ top: 20 }}
        onOk={() => {
          formEdit.submit();
        }}
        cancelText="ยกเลิก"
        okText="ตกลง">
        <Form form={formEdit} {...formItemLayout} onFinish={onEdit}>
          <UpdateAgentAddressForm
            form={formEdit}
            masterLocationData={masterLocationData}
            masterTransportData={TransportationTypeData?.data}
            masterProviceData={masterProviceData}
            masterDistrictData={masterDistrictData}
            masterSubDistrictData={masterSubDistrictData}
            selectedLocation={selectedLocationEdit}
            setSelectedLocation={setSelectedLocationEdit}
            setProvinceId={setProvinceId}
            setDistrictId={setDistrictId}
          />
        </Form>
      </Modal>
    </>
  );
};

export default ModalUpdateOrder;

const StyledButton = styled(Button)`
  margin-right: 5px;
`;
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0px 10px 0px 10px;
  margin-bottom: 10px;
  & > :first-child {
    flex: 3;
  }

  & > :last-child {
    flex: 7;
    display: flex;
    justify-content: flex-end;
  }
`;
const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
